import {adminAxios} from '@/Plugins/Axios';

/**
 * admin › ຂໍ້ມູນລູກຄ້າ › ລະຫັດ PIN ພິເສດ — PINs that confirm a customer's shipment update requests.
 * BFF: api/admin/customer-special-pins (SuperAdmin only). The PIN itself comes back once, from issuePin.
 */
const ROOT = 'customer-special-pins/customers';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : res.data);

/** Customers whose login phone starts with q (≥ 4 digits). Returns [{id, name, tel, live_special_pins}]. */
export async function searchCustomers(q) {
    const res = await adminAxios.get(ROOT, {params: {q}});
    const data = unwrap(res);
    return Array.isArray(data) ? data : [];
}

/** {customer: {id, name, tel, live_special_pins, max_special_pins}, special_pins: [...]}, removed PINs included. */
export async function fetchCustomerPins(userId) {
    const res = await adminAxios.get(`${ROOT}/${userId}`);
    return unwrap(res);
}

/** {pin, special_pin} — the only response that ever carries the PIN. */
export async function issuePin(userId, label) {
    const res = await adminAxios.post(`${ROOT}/${userId}`, {label});
    return unwrap(res);
}

export async function removePin(userId, pinId) {
    const res = await adminAxios.delete(`${ROOT}/${userId}/${pinId}`);
    return unwrap(res);
}

/** Laravel 422 → its first field error; a refusal ({error, message, data: {reason}}) → its message. */
export function errorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    if (data && data.errors) {
        const first = Object.values(data.errors).flat()[0];
        if (first) return first;
    }
    return (data && data.message) || fallback;
}
